<template>
  <el-scrollbar>
    <eco-tree
      :data="treeData"
      :props="defaultProps"
      :support-filter="supportFilter"
      :highlight-current="highlightCurrent"
      :default-expand-all="defaultExpandAll"
      :default-expanded-keys="_defaultExpandedKeys"
      node-key="id"
      :show-checkbox="showCheckbox"
      :render-content="renderContent"
      :expand-on-click-node="false"
      @refresh="handleRefresh"
      @node-click="handleNodeClick"
      @check="check"
      ref="ecoTree"
    >
      <!-- 作用域插槽：插槽prop -->
      <slot slot-scope="{ node, data }" :node="node" :data="data"></slot>
    </eco-tree>
  </el-scrollbar>
</template>

<script>
import sys from "@/api/sysType.js";
/**
 公告分类
  ANNOUNCEMENT_TYPE

  新闻分类
  NEWS_TYPE

  制度发文分类
  REGULATIONS_TYPE
 */
export default {
  name: "fe-sys-type-tree",
  props: {
    catId: {
      type: String || Number,
      default: ""
    },
    typeKey: {
      type: String || Number,
      default: ""
    },
    supportFilter: {
      type: Boolean,
      default: false
    },
    highlightCurrent: {
      type: Boolean,
      default: false
    },
    defaultExpandAll: {
      type: Boolean,
      default: false
    },
    defaultExpandedKeys: {
      type: Array,
      default() {
        return [];
      }
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    renderContent: {
      type: Function
    }
  },
  data() {
    return {
      treeData: [],
      defaultProps: {
        children: "children",
        label: "name"
      },
      _defaultExpandedKeys: []
    };
  },
  watch: {
    defaultExpandedKeys: {
      handler(newVal, oldVal) {
        if (newVal && newVal != oldVal) {
          this._defaultExpandedKeys = newVal;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleNodeClick(node) {
      this.$emit("node-click", node);
    },
    check(data, checkedObj) {
      this.$emit("check", data, checkedObj);
    },
    loadData(cb) {
      if (this.typeKey) {
        sys.getTypesByKey(this.typeKey).then(data => {
          this.treeData = data;
          sessionStorage.setItem("tree", JSON.stringify(data));
          cb && cb();
        });
      }
    },
    handleRefresh(cb) {
      this.loadData(cb);
    }
  },
  mounted() {
    this._defaultExpandedKeys = [this.catId];
    this.loadData();
  }
};
</script>
<style lang="scss" scoped>
>>> .el-tree .el-tree__empty-block {
  margin: 20px 20px;
}

>>> .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
